module.exports = __webpack_public_path__ + "static/media/strokewidth-icon.82930ec3.svg";